/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:reqLottCartaDebitoInt
 * @restrict E
 * @description Componente per la visualizzazione di richiesta lotto
 */
(function () {
  'use strict';
  var ReqLottCartaDebitoIntCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    domainSrvc,
    reqLottCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.reqLottCtrl = this;

    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.loggerSrvc = loggerSrvc;
    this.domainSrvc = domainSrvc;
    this.reqLottCartaDebitoIntSrvc = reqLottCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Istanza della Form di richiesta lotto
     */
    this.formReqlott;

    /**
     * Tendina provincie.
     */
    this.province = [];

    /**
     * Tendina comuni.
     */
    this.comuni = [];

    /**
     * Tendina cap.
     */
    this.cap = [];

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.reqLottCartaDebitoIntSrvc.spinner;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di abilitazione del pulsante "richiedi"
     */
    this.reqLottCartaDebitoIntSrvc.richiediAbilitato = function () {
      return self.formValido();
    };

    this.avanza = function () {
      if (this.formReqlott.$valid) {
        // Chiamata al be MF per sottomettere la richiesta
        self.richiestaReqLott();
      }
    };

    this.richiestaReqLott = function () {
      // invio i dati per richiesta
      self.spinner.showSpinner = true;

      return self.reqLottCartaDebitoIntSrvc
        .promiseRichiesta(
          self.reqLottCartaDebitoIntSrvc.currentProdotto,
          self.reqLottCartaDebitoIntSrvc.currentNumeroCarte,
          self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.showSpinner = false;
              return;
            }
            self.reqLottCartaDebitoIntSrvc.resetData();
            self.$state.go('home', { ndg: null });
          },
          function (reason) {
            self.spinner.showSpinner = false;
            self.messaggiFctr.processaResponse(reason);
          }
        );
    };

    /**
     * Verifica se i dati inseriti nel form sono validi
     */
    this.formValido = function () {
      return (
        // devono essere riempiti
        !!self.reqLottCartaDebitoIntSrvc.currentNumeroCarte &&
        !!self.reqLottCartaDebitoIntSrvc.currentProdotto &&
        // devono essere numerici
        angular.isNumber(self.reqLottCartaDebitoIntSrvc.currentNumeroCarte) &&
        self.reqLottCartaDebitoIntSrvc.currentNumeroCarte > 0
      );
    };

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:reqLottCartaDebitoInt
     * @description Recupera i comuni per la spedizione.
     */
    this.recuperaComuni = function() {
      var provincia = self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.provincia;
      if (provincia == null) {
        self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.comune = null;
        self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.cap = null;
        return;
      }

      self.spinner.showSpinner = true;

      self.domainSrvc
        .promiseDomain('COMUNE', provincia)
        .then(function (domain) {
          self.comuni = domain;

          // Se il valore comune è pre valorizzato correttamente procedo il caricamento dei CAP
          if (self.isProcessNextList(self.comuni, self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.comune)) {
            self.recuperaCAP();
            return;
          }

          self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.comune = null;
          self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.cap = null;
          self.spinner.showSpinner = false;
        }, function(reason) {
          console.error(reason);
          self.spinner.showSpinner = false;
        });
    }

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:reqLottCartaDebitoInt
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function () {
      var comune = self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.comune;
      if (comune == null) {
        self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.cap = null;
        return;
      }

      self.spinner.showSpinner = true;

      self.domainSrvc
        .promiseDomain('CAP', comune)
        .then(function (domain) {
          self.cap = domain;

          if (self.isProcessNextList(self.cap, self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.cap)) {
            return;
          }

          self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.cap = null;

        })
        .finally(function () {
          self.spinner.showSpinner = false;
        });
    };

    /**
     * @ngdoc method
     * @name isProcessNextList
     * @methodOf cbl.cartadebitoint.wa:reqLottCartaDebitoInt
     * @description Torna true se il valore è in lista è presente in lista.
     */
    this.isProcessNextList = function(list , value) {
      if (value == null) {
        return false;
      }

      var selected = list.filter(function(item) {
        return value === item.codice;
      });

      return selected.length > 0;
    }

    /**
     * ===== GESTIONE BOTTONIERA A PIÉ DI PAGINA =====
     */

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      // Forzatura per lo spegnimento dello spinner generale dell'applicazione per poter gestire
      // correttamente quello locale.
      var overlay = document.getElementById('overlay');
      if (!!overlay) {
        overlay.setAttribute('style', 'display: none;');
      }

      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        // recupero delle carte per il codice prodotto
        self.spinner.showSpinner = true;
        $q.all([
          self.domainSrvc.promiseDomain('PROVINCIA'),
          self.reqLottCartaDebitoIntSrvc.promiseRecuperaIndirizzoDefault(CONSTANTS.REST.REQ_LOTT.RECUPERA_LISTA_PRODOTTI),
          // self.reqLottCartaDebitoIntSrvc.promiseRecuperaDominio(CONSTANTS.REST.REQ_LOTT.RECUPERA_LISTA_PRODOTTI),
          self.reqLottCartaDebitoIntSrvc.promiseRecuperaIndirizzoDefault(
            CONSTANTS.REST.REQ_LOTT.RECUPERA_INDIRIZZI_DEFAULT
          )
        ]).then(
          function (response) {
            self.province = response[0];

            // Rimuovo stato estero perché indirizzo di spedizione è sempre italia
            self.province = response[0].filter(function (value) {
              return value.codice !== '**';
            });

            self.reqLottCartaDebitoIntSrvc.elencoProdotto = response[1].data.result;
            self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione = response[2].data.result;

            // Se la provincia è pre valorizzata in modo corretto procedo con il caricamento dei comuni
            if (self.isProcessNextList(self.province,
                                       self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.provincia)) {
              self.recuperaComuni();
              return;
            }
            self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.provincia = null;
            self.spinner.showSpinner = false;
          },
          function (reason) {
            console.error(reason);
            self.spinner.showSpinner = false;
          }
        );
      });
    };

    self.init();
  };


  ReqLottCartaDebitoIntCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'CdintDomainSrvc',
    'ReqLottCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'reqLottCartaDebitoInt/reqLottCartaDebitoInt.html';
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var ReqLottCartaDebitoIntComponent = {
    controller: ReqLottCartaDebitoIntCtrl,
    controllerAs: 'reqLottCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('reqLottCartaDebitoInt', ReqLottCartaDebitoIntComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/reqLottCartaDebitoInt/reqLottCartaDebitoInt.cmpt.js
// module id = 22
// module chunks = 0